<div class=" loading" *ngIf="loader">Loading&#8230;</div>
<!-- new html -->
<div class="row no-gutters content_top_margin bot_spa_aft_sect_heading">
    <div class="col-12">
        <label for="inputIncome">
            <span *ngIf="isCoapplicantApplied && !isExistingCustomer; else conditionNotSatisfied" id="incomeLabel"
                class="sectionHeading_one" role="heading" aria-level="2"> {{
                'about.coapplicantTitleTextBox' | translate }}</span>
            <ng-template #conditionNotSatisfied>
                <span id="incomeLabel" class="sectionHeading_one" role="heading" aria-level="2"> {{ 'about.titleTextBox' | translate }}</span>
            </ng-template>
        </label>
    </div>
</div>
<ng-container *ngIf="(!isCoapplicantApplied && !isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters bot_spa_aft_sect_heading" *ngIf="isCoapplicantApplied && !isExistingCustomer">
        <div class="col-12"><span id="applicant" class="sectionHeading_two " role="heading" aria-level="3"> {{
                'information.applicant' | translate }}</span></div>
    </div>
    <form [formGroup]="aboutForm">
        <div class="space_between_section">
            <div class="row bot_spa_aft_sect_heading no-gutters">
                <div class="col-12 col-md-5 col-lg-4">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label class="field_lable_bot_margin_unset" for="firstName" id="applicantFirstName">{{
                            'about.firstname' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" tabindex="0" #first style="text-transform: uppercase"
                        formControlName="firstName" (keyup)="TempSave()" aria-labelledby="applicant applicantFirstName"
                        aria-describedby="applicant appErrorMsg" [readonly]="loader" id="firstName" autocomplete="given-name"
                        spellcheck="false" #firstName aria-required="true" required
                        [ngClass]="(f.firstName.touched || submitted) && (f.firstName.errors?.invalidName || f.firstName.errors?.required||f.firstName.errors?.minLength||f.firstName.errors?.startsWithApostrophe||f.firstName.errors?.startsWithHyphen||f.firstName.errors?.noCharacter) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="15">
                    <div class="row no-gutters"
                        *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched || submitted)">
                        <div class="col-12" id="appErrorMsg">
                            <small class="d-flex align-items-start mt-1 errorMsg">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <ng-container *ngIf="f.firstName.errors?.minLength">
                                    <span class="ml-2">{{ 'about.lengthValidation' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.firstName.errors?.startsWithHyphen">
                                    <span class="ml-2">{{ 'about.hyphenValidation' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.firstName.errors?.noCharacter||f.firstName.errors?.invalidName">
                                    <span class="ml-2">{{ 'about.fnerrormsg' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.firstName.errors?.startsWithApostrophe">
                                    <span class="ml-2">{{ 'about.apostropheValidation' | translate }}</span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-4 space_between_field space_between_field_right">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="lastName" id="applicantLastname" class="field_lable_bot_margin_unset">{{
                            'about.lastname' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" tabindex="0" (keyup)="TempSave()" #last
                        style="text-transform: uppercase" formControlName="lastName" [readonly]="loader"
                        aria-labelledby="applicant applicantLastname" aria-describedby="applicant applstNameErrorMsg" id="lastName"
                        spellcheck="false" autocomplete="family-name" #lastName aria-required="true" required
                        [ngClass]="(f.lastName.touched || submitted) && (f.lastName.errors?.invalidName || f.lastName.errors?.required||f.lastName.errors?.startsWithApostrophe||f.lastName.errors?.startsWithHyphen||f.lastName.errors?.minLength||f.lastName.errors?.noCharacter) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="20">
                    <div class="row no-gutters"
                        *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched || submitted)">
                        <div class="col-12" id="applstNameErrorMsg">
                            <small class="d-flex align-items-start errorMsg mt-1">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <ng-container *ngIf="f.lastName.errors?.minLength">
                                    <span class="ml-2">{{ 'about.lengthValidationLastName' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.lastName.errors?.startsWithHyphen">
                                    <span class="ml-2">{{ 'about.hyphenValidation' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.lastName.errors?.noCharacter||f.lastName.errors?.invalidName">
                                    <span class="ml-2">{{ 'about.lnerrormsg' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="f.lastName.errors?.startsWithApostrophe">
                                    <span class="ml-2">{{ 'about.apostropheValidation' | translate }}</span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-2 space_between_field_right topSpace">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="suffix" id="applicantSuffix" class="field_lable_bot_margin_unset">{{
                            'about.suffix' | translate }}
                        </label>
                    </small>
                    <select class="wdd-fl border-cls nonSelectBorder" tabindex="0" (keyup)="TempSave()"
                        formControlName="suffix" id="suffix" aria-labelledby="applicant applicantSuffix">
                        <option value=""></option>
                        <option *ngFor="let suffix of suffixList" [ngValue]="suffix">{{suffix}}</option>
                    </select>

                </div>
                <div class="col-12 col-md-5 col-lg-4 top_spa_aft_sect_heading">
                    <small class=" form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="dp" id="applicantdp" class="field_lable_bot_margin_unset">{{ 'about.dob' |
                            translate }}
                        </label>
                    </small>
                    <div class="input-group ">
                        <input class="form-control dob  mobileCalendar" id="dp" name="dp" formControlName="DOB" readonly ngbDatepicker
                            #dp="ngbDatepicker" required [maxDate]="maxPickerDate" aria-describedby="applicant errorDOB" placeholder="mm/dd/yyyy"
                            aria-labelledby="applicant applicantdp" [minDate]="minPickerDate"
                            (dateSelect)="onDateSelect($event);TempSave()" [footerTemplate]="footerTemplate" [dayTemplate]="customDay"
                            [markDisabled]="isDisabled"
                            [ngClass]="(f.DOB.touched || submitted) && (f.DOB.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                        <div class="input-group-append">
                            <button class=" btn btn-outline-secondary calendar dobCalender mobileCalendar" id="cb" name="cb"
                                (click)="dp.toggle(); selectDisable()"
                                [ngClass]="(f.DOB.touched || submitted) && (f.DOB.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'"
                                type="button" aria-labelledby="dobSelection">
                
                                <img class="logoImg" src="../../../assets/icons/NewIcons/CIBC_calendar.svg" alt="" />
                            </button>
                            <span id="dobSelected" aria-hidden="true" class="show-for-sr">{{ 'about.dobSelected'
                                |
                                translate }}</span>
                            <span id="dateSelected" class="show-for-sr"></span>
                            <span id="dobSelection" aria-hidden="true" class="show-for-sr">{{
                                'about.dobSelection' |
                                translate }}</span>
                        </div>
                    </div>
                    <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
                        let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.bg-primary]="selected"
                            [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                            {{ date.day }}
                        </span>
                    </ng-template>
                    <ng-template #footerTemplate>
                        <hr class="my-0">
                
                        <button type="button" (click)="dp.close()" tabindex="0"
                            class="closeBtn common_btn btn-sm m-2 float-right cl-rd ml-md-3 mt-md-3">{{
                            'buttonallpages.close' | translate }}</button>
                    </ng-template>
                    <div class="row no-gutters" *ngIf="f.DOB.invalid && (f.DOB.dirty || f.DOB.touched || submitted)">
                        <div class="col-12">
                            <small class="d-flex align-items-center errorMsg mt-1" id="errorDOB">
                                <ng-container *ngIf="f.DOB.errors?.required">
                                    <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                    <span class="ml-2">
                                        {{'about.doberrormsg' | translate}}
                                    </span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-container>
<ng-container *ngIf="(isCoapplicantApplied && isExistingCustomer) || (isCoapplicantApplied && !isExistingCustomer)">
    <div class="row no-gutters bot_spa_aft_sect_heading" *ngIf="isCoapplicantApplied && !isExistingCustomer">
        <div class="col-12"><span id="coApplicantTitle" class="sectionHeading_two" role="heading" aria-level="3">
                {{
                'information.coApplicant' | translate
                }}
            </span>
        </div>
    </div>
    <form [formGroup]="coapplicantAboutForm">
        <div class="space_between_section">
            <div class="row bot_spa_aft_sect_heading no-gutters">
                <div class="col-12 col-md-5 col-lg-4">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="firstName" id="coappFirstname">{{ 'about.firstname' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" tabindex="0" #first style="text-transform: uppercase"
                        formControlName="firstName" aria-labelledby="coApplicantTitle coappFirstname"
                        aria-describedby="coApplicantTitle coappErrMsg" (keyup)="coapplicantTempSave()" [readonly]="loader"
                        id="firstName" autocomplete="given-name" spellcheck="false" #firstName aria-required="true"
                        required
                        [ngClass]="(cf.firstName.touched || coSubmitted) && (cf.firstName.errors?.invalidName || cf.firstName.errors?.required||cf.firstName.errors?.startsWithApostrophe||cf.firstName.errors?.startsWithHyphen||cf.firstName.errors?.minLength||cf.firstName.errors?.noCharacter) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="15">
                    <div class="row no-gutters"
                        *ngIf="cf.firstName.invalid && (cf.firstName.dirty || cf.firstName.touched || coSubmitted)">
                        <div class="col-12" id="coappErrMsg">
                            <small class="d-flex align-items-start errorMsg mt-1">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <ng-container *ngIf="cf.firstName.errors?.minLength">
                                    <span class="ml-2">{{ 'about.lengthValidation' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="cf.firstName.errors?.startsWithHyphen">
                                    <span class="ml-2">{{ 'about.hyphenValidation' | translate }}</span>
                                </ng-container>
                                <ng-container
                                    *ngIf="cf.firstName.errors?.noCharacter||cf.firstName.errors?.invalidName">
                                    <span class="ml-2">{{ 'about.fnerrormsg' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="cf.firstName.errors?.startsWithApostrophe">
                                    <span class="ml-2">{{ 'about.apostropheValidation' | translate }}</span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-4 space_between_field space_between_field_right">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="lastName" id="coappLastname">{{ 'about.lastname' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" tabindex="0" (keyup)="coapplicantTempSave()"
                        autocomplete="family-name" #last style="text-transform: uppercase" formControlName="lastName"
                        [readonly]="loader" id="lastName" spellcheck="false" #lastName
                        aria-labelledby="coApplicantTitle coappLastname" aria-describedby="coApplicantTitle coapplstNameErrMsg"
                        aria-required="true" required
                        [ngClass]="(cf.lastName.touched || coSubmitted) && (cf.lastName.errors?.invalidName || cf.lastName.errors?.required||cf.lastName.errors?.startsWithApostrophe||cf.lastName.errors?.startsWithHyphen||cf.lastName.errors?.minLength||cf.lastName.errors?.noCharacter) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="20">
                    <div class="row no-gutters"
                        *ngIf="cf.lastName.invalid && (cf.lastName.dirty || cf.lastName.touched || coSubmitted)">
                        <div class="col-12" id="coapplstNameErrMsg">
                            <small class="d-flex align-items-start errorMsg mt-1">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <ng-container *ngIf="cf.lastName.errors?.minLength">
                                    <span class="ml-2">{{ 'about.lengthValidationLastName' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="cf.lastName.errors?.startsWithHyphen">
                                    <span class="ml-2">{{ 'about.hyphenValidation' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="cf.lastName.errors?.noCharacter||cf.lastName.errors?.invalidName">
                                    <span class="ml-2" >{{ 'about.lnerrormsg' | translate }}</span>
                                </ng-container>
                                <ng-container *ngIf="cf.lastName.errors?.startsWithApostrophe">
                                    <span class="ml-2">{{ 'about.apostropheValidation' | translate }}</span>
                                </ng-container>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-2  space_between_field_right topSpace">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="suffix" id="coappSuffix" class="field_lable_bot_margin_unset">{{ 'about.suffix' |
                            translate }}
                        </label>
                    </small>
                    <select class="wdd-fl border-cls nonSelectBorder" tabindex="0" (keyup)="coapplicantTempSave()"
                        formControlName="suffix" id="suffix" aria-labelledby="coApplicantTitle coappSuffix">
                        <option value=""></option>
                        <option *ngFor="let suffix of suffixList" [ngValue]="suffix">{{suffix}}</option>
                    </select>
                </div>
                <div class="col-12 col-md-5 col-lg-4 top_spa_aft_sect_heading">
                    <small class=" form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="cdp" id="coappCdp" class="field_lable_bot_margin_unset">{{ 'about.dob' | translate }}
                        </label>
                    </small>
                    <div class="input-group">
                        <input class="form-control dob  mobileCalendar" id="cdp" name="cdp" formControlName="DOB" readonly ngbDatepicker
                            #cdp="ngbDatepicker" required [maxDate]="maxPickerDate" aria-describedby="coApplicantTitle coErrorDOB"
                            placeholder="mm/dd/yyyy" [minDate]="minPickerDate" aria-labelledby="coApplicantTitle coappCdp"
                            (dateSelect)="onCoapplicantDateSelect($event);coapplicantTempSave()" [footerTemplate]="footerTemplate"
                            [dayTemplate]="customDay" [markDisabled]="isDisabled"
                            [ngClass]="(cf.DOB.touched || coSubmitted) && (cf.DOB.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                        <div class="input-group-append">
                            <button class=" btn btn-outline-secondary calendar dobCalender mobileCalendar" id="ccb" name="ccb"
                                (click)="cdp.toggle(); selectDisable()"
                                [ngClass]="(cf.DOB.touched || coSubmitted) && (cf.DOB.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'"
                                type="button" aria-labelledby="coDobSelection">
                
                                <img class="logoImg" src="../../../assets/icons/NewIcons/CIBC_calendar.svg" alt="" />
                            </button>
                            <span id="dobSelected" aria-hidden="true" class="show-for-sr">{{ 'about.dobSelected'
                                |
                                translate }}</span>
                            <span id="dateSelected" class="show-for-sr"></span>
                            <span id="coDobSelection" aria-hidden="true" class="show-for-sr">{{
                                'about.dobSelection' |
                                translate }}</span>
                        </div>
                    </div>
                    <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
                        let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.bg-primary]="selected"
                            [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                            {{ date.day }}
                        </span>
                    </ng-template>
                    <ng-template #footerTemplate>
                        <hr class="my-0">
                        <button type="button" (click)="cdp.close()" tabindex="0"
                            class="closeBtn buttonCommon btn-sm m-2 float-right cl-rd ml-md-3 mt-md-3">{{
                            'buttonallpages.close' | translate }}</button>
                    </ng-template>
                    <div class="row no-gutters" *ngIf="cf.DOB.invalid && (cf.DOB.dirty || cf.DOB.touched || coSubmitted)">
                        <div class="col-12" id="coErrorDOB">
                            <small class="d-flex align-items-start errorMsg mt-1">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'about.doberrormsg' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    </form>
</ng-container>
<div class="row no-gutters">
    <div class="col-12 noteContainer d-flex align-items-start">
        <img src="./assets/icons/info-square-filled.svg" alt="" class="pr-2">
        <span *ngIf="preQualObj.flow_type==prequalType" id="personalInformationAboutYourselfContent">{{
            'about.aboutYourselfTip' | translate }} </span>
        <span *ngIf="preQualObj.flow_type === switchType" id="personalInformationAboutYourselfContent">{{
            'about.digiAboutYourselfTip' | translate }} </span>
    </div>
</div>
<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
    <div class="col-12 d-md-block d-flex  flex-column-reverse">
        <cancel-button></cancel-button>
        <button type="button" class="common_btn saveNextBtn_features space_between_button"
            (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
    </div>
</div>